module.exports = __webpack_public_path__ + "img/animateur-radio.55ee9ebe.jpg";